import AppointmentsList from './_AppointmentsList';

export default AppointmentsList;
